import React, { FC } from 'react';
import { Appearance, Button } from '@src/components/Button';
import { useAppDispatch } from '@src/redux';
import { setModalContent } from '@src/redux/actions/modal';
import FastTrackModal from '@src/components/FastTrackModal';
import { trackEvent, trackViewCreateTargeting } from '@src/metrics';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { useSessionQuery } from '@src/graphql/generated';
import { NEW_FUNNEL_ROUTE } from '@src/Routes/links';
import { Container } from '@src/components/Container';
import { FrankLogoGlow } from '@src/components/FrankLogoGlow';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import './styles.scss';

export const StartTargetingTalent: FC = () => {
  const dispatch = useAppDispatch();

  const { data: sessionData } = useSessionQuery();

  const company = sessionData?.company;

  const openModal = () => {
    if (!company?.operationsEmail) {
      return;
    }

    dispatch(setModalContent(<FastTrackModal companyId={company?.id} email={company?.operationsEmail} />));

    trackEvent({
      context: MetricContext.OPENINGS_PAGE,
      interaction: MetricAction.OPEN_FAST_TRACK_VIEW,
      payload: {
        'Event Source': MetricEventSource.TOP_SECTION_BUTTON,
      },
    });
  };

  return (
    <Container className="targeting-talent" type={ContainerType.BORDERED}>
      <div className="targeting-talent__left-section">
        <FrankLogoGlow className="targeting-talent__glow" />

        <div className="targeting-talent__copies">
          <h3 className="targeting-talent__title">Start finding talent</h3>

          <p className="targeting-talent__sub-title">Post your job opening and hire the best talent available.</p>
        </div>
      </div>
      <div className="targeting-talent__right-section">
        <Button appearance={Appearance.INVISIBLE} onClick={openModal}>
          Send us a link
        </Button>

        <span className="targeting-talent__actions-connect">or</span>

        <Button
          appearance={Appearance.PRIMARY}
          isLink
          onClick={() =>
            trackViewCreateTargeting({
              'Event Source': MetricEventSource.TOP_SECTION_BUTTON,
              'Previous Context': MetricContext.OPENINGS_PAGE,
            })
          }
          to={NEW_FUNNEL_ROUTE}
        >
          Post a job
        </Button>
      </div>
    </Container>
  );
};
